/* eslint-disable react/jsx-pascal-case */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import { OrderList } from "../../../Component/Interface/Order";
import url from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import {
  CenterView,
  CheckBox,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import { XLSX_down_ } from "../../../Component/tool/xlsx_download";
import { uploadXLSX } from "../../../Component/tool/xlsx_upload";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import Order_all from "./Component/Order_all";
import Order_cancel from "./Component/Order_cancel";
import Order_paydeil from "./Component/Order_paydeil";
import Order_refound from "./Component/Order_refound";
import Order_select_menu from "./Component/Order_select_menu";
import No_stock from "./Modal/No_stock";
import Product_list from "./Modal/Product_list";

const pages = [
  { name: "미입금", key: "non-pay" },
  { name: "입금확인", key: "done-pay" },
  { name: "배송준비", key: "ready-deli" },
  { name: "배송완료", key: "done-deli" },
  { name: "주문취소", key: "cancle" },
  { name: "환불처리", key: "refound" },
  { name: "전체", key: "all" },
];

const Orderlist = () => {
  const Navigate = useNavigate();
  const { page = "" } = useParams();
  const pagename = pages.filter((item) => item.key === page)[0].name;

  const menuList = ["미입금", "입금확인", "배송준비", "배송완료"];
  const show_엑셀업로드 = page === "done-pay";
  const show_엑셀내보내기 = page !== "all";
  const show_삭제 = page === "cancle";

  const menuRef = useRef<{ get_order_count: () => void } | null>(null);
  const cnt_reload = () => {
    if (menuRef.current) {
      menuRef.current.get_order_count();
    }
  };

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [pre_search_value, setPre_Search_value] = useState("");
  const [pre_search_startDt, setPre_Search_startDt] = useState("");
  const [pre_search_endDt, setPre_Search_endDt] = useState("");

  const [search_key, setSearch_key] = useState("order_name");
  const [search_value, setSearch_value] = useState("");
  const [search_startDt, setSearch_startDt] = useState("");
  const [search_endDt, setSearch_endDt] = useState("");
  const [search_item, setSearch_item] = useState("");

  const [total, setTotal] = useState(5);
  const [list, setList] = useState<OrderList[]>([]);
  const [isFinish, setIsFinis] = useState(false); // 마지막 입니다. 문구
  const [stockModal, setStockModal] = useState(false);
  const handleStockModal = () => setStockModal(!stockModal);
  const [open_productList, setOpen_productList] = useState(false);
  const handleOpen_productList = () => setOpen_productList(!open_productList);

  const setting_search_key = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setSearch_key(e.target.value);
  const setting_pre_search_value = (e: React.ChangeEvent<HTMLInputElement>) =>
    setPre_Search_value(e.target.value);
  const setting_pre_search_startDt = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPre_Search_startDt(e.target.value);
    if (pre_search_endDt === "") setPre_Search_endDt(e.target.value);
  };
  const setting_pre_search_endDT = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPre_Search_endDt(e.target.value);
    if (pre_search_startDt === "") setPre_Search_startDt(e.target.value);
  };
  const keyPress_keyword = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") search();
  };

  const del_search_value = () => setSearch_value("");
  const del_search_item = () => setSearch_item("");
  const del_search_date = () => {
    setSearch_startDt("");
    setSearch_endDt("");
  };
  const reset = () => window.location.reload();
  const data_reset = (search_reset: boolean) => {
    // 언제 수정하지...
    setCurrentPage(1); // 1페이지로
    setIsFinis(false); // 마지막입니다 off
    // setLoading(true); // loading
    // setList([]); // list 초기화
    setSelectOrder([]); // checkbox 초기화
    setSelect_status("");
    if (search_reset) {
      // 검색어 초기화
      setPre_Search_value("");
      setPre_Search_startDt("");
      setPre_Search_endDt("");
      setSearch_value("");
      setSearch_startDt("");
      setSearch_endDt("");
      setSearch_item("");
    }
  };
  const go_page = useCallback((key: string) => {
    data_reset(true);
    Navigate(`/admin/orderlist/${key}`);
  }, []);

  const get_order_list = async (currentPageNum: number, del?: true) => {
    const menu = pages.find((data) => data.key === page);
    setLoading(true);
    try {
      const res = await api.get(url.Communication_url.get_order_list, {
        params: {
          order_status: menu?.name,
          current_page: currentPageNum,
          per_page: 50,
          ...(search_value !== "" && {
            search_key: search_key,
            search_value: search_value,
          }),
          ...(search_startDt !== "" && {
            start_dt: search_startDt,
            end_dt: search_endDt,
          }),
          ...(search_item !== "" && {
            product_name: search_item,
          }),
        },
      });
      // console.log(page, currentPageNum, res.data);
      const total = parseInt(res.data.total) || 0;
      const datalist = res.data.orderList || [];
      setTotal(total);
      if (datalist.length === 0) {
        setIsFinis(true);
        setLoading(false);
        if (del || total === 0) {
          setList([]);
        }
        return;
      }
      let copyArr;
      if (currentPageNum === 1) {
        copyArr = [...datalist];
      } else {
        copyArr = [...list, ...datalist];
      }
      setList(copyArr);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    data_reset(false);

    setTimeout(() => {
      get_order_list(1);
    }, 0);
  }, [page, search_value, search_startDt, search_endDt, search_item]);

  useEffect(() => {
    if (currentPage > 1 && !loading && !isFinish) {
      get_order_list(currentPage);
    }
  }, [currentPage]);

  const search = () => {
    if (
      pre_search_value === "" &&
      pre_search_startDt === "" &&
      pre_search_endDt === ""
    ) {
      alert("검색어를 입력해주세요.");
      return;
    }
    // if(pre_search_startDt ==='' && pre_search_ ==='')
    setSearch_value(pre_search_value);
    setSearch_startDt(pre_search_startDt);
    setSearch_endDt(pre_search_endDt);
  };

  const [loading_, setLoading_] = useState(false);
  const [select_status, setSelect_status] = useState("");
  const [selectOrder, setSelectOrder] = useState<number[]>([]);

  const set주문상태 = (order_status: string) => {
    if (loading_) return;
    if (select_status !== "") return update_all_order_status(order_status);
    if (selectOrder.length === 0) return;
    if (
      ["환불처리"].includes(order_status) &&
      !window.confirm(
        `해당 주문을 ${order_status} 하시겠습니까?\n${order_status} 후 되돌릴 수 없습니다.`
      )
    ) {
      return;
    }
    const data = {
      detail_seq_list: selectOrder,
      current_status: pagename,
      change_status: order_status,
    };

    update_order_detail(data);
  };
  const set모든주문선택 = () => {
    if (total === 0) return;
    if (select_status === "") {
      const menuname = pages.find((data) => data.key === page)?.name || "";
      setSelect_status(menuname);
      setSelectOrder([]);
    } else {
      setSelect_status("");
    }
  };
  const update_all_order_status = async (change_status: string) => {
    if (
      ["환불처리"].includes(change_status) &&
      !window.confirm(
        `모두 ${change_status} 하시겠습니까?\n${change_status} 후 되돌릴 수 없습니다.`
      )
    ) {
      return;
    }

    try {
      const res = await api.patch(
        url.Communication_url.update_all_order_status,
        {
          current_status: select_status,
          change_status: change_status,
          ...(search_value !== "" && {
            search_key: search_key,
            search_value: search_value,
          }),
          ...(search_startDt !== "" && {
            start_dt: search_startDt,
            end_dt: search_endDt,
          }),
          ...(search_item !== "" && {
            product_name: search_item,
          }),
        }
      );
      // console.log(res.data);
      const success = res.data.success;
      alert(`총 ${success}건이 이동되었습니다.`);
      if (success > 0) {
        Navigate(0);
      }
    } catch (error) {
      console.error("api 실패: ", error);
    }
  };

  /* 엑셀 */
  const uploadRef = useRef<HTMLInputElement | null>(null);
  const clickBtn = () => {
    if (uploadRef.current) {
      uploadRef.current.click();
    }
  };
  const upload_xlxs = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      try {
        const data = await uploadXLSX(files[0]);
        update_order_detail(data, true); // 주문상태 변경
      } catch (error) {
        console.error(error);
      }
    }
  };
  // 엑셀 내보내기
  const download_xlxs = async () => {
    if (list.length === 0) {
      return alert("데이터가 없습니다.");
    }
    const menu = pages.find((data) => data.key === page);
    try {
      const res = await api.get(url.Communication_url.get_order_list, {
        params: { order_status: menu?.name },
      });
      XLSX_down_(res.data.orderList, menu?.name || "");
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };

  /* 주문 상태 변경 */
  const modify_memo = useCallback((seq: number, type: string, data: string) => {
    const send_data = [{ seq: seq, [type]: data }];
    update_order_detail(send_data, true);
  }, []);

  const update_order_detail = async (send_data: any, isGoGO?: boolean) => {
    if (selectOrder.length === 0 && !isGoGO) {
      return;
    }
    setLoading_(true);

    try {
      const res = await api.patch(
        url.Communication_url.order_detail_update,
        send_data,
        { headers: { "Content-Type": "application/json" } }
      );

      const total = res.data.total;
      const success = res.data.success;
      const fail = res.data.fail;

      if (pagename === "주문취소" && fail === 1) {
        setStockModal(true);
      } else if (total === success) {
        alert("상태 변경이 완료되었습니다.");
      } else {
        alert(`상태 변경 성공 ${success}건 (실패: ${fail}/${total}건)`);
      }

      cnt_reload(); // 메뉴 cnt reload
      get_order_list(1); // 주문내역 reload
      setSelectOrder([]);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    } finally {
      setLoading_(false);
    }
  };
  const order_delete = async () => {
    if (!window.confirm("정말로 삭제하시겠습니까?")) {
      return;
    }
    try {
      const res = await api.delete(url.Communication_url.order_delete, {
        data: { detail_seq_list: selectOrder },
      });

      const total = res.data.total;
      const success = res.data.success;
      const fail = res.data.fail;

      if (total === success) {
        alert("삭제 완료되었습니다.");
      } else {
        alert(`삭제 성공 ${success}건 (실패: ${fail}/${total}건)`);
      }
      cnt_reload(); // 메뉴 cnt reload
      get_order_list(1, true); // 주문내역 reload + del 하드코딩 ...
      setSelectOrder([]);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    } finally {
      setLoading_(false);
    }
  };

  // 무한 스크롤 페이징
  const gogo = (entries: IntersectionObserverEntry[]) => {
    const target = entries[0];
    if (target.isIntersecting && !loading) {
      setCurrentPage((pre) => pre + 1);
    }
  };
  useEffect(() => {
    if (isFinish) return;
    const observer = new IntersectionObserver(gogo, { threshold: 0 });
    const observerTarget = document.getElementById("observer");
    if (observerTarget) {
      observer.observe(observerTarget);
    }
    return () => {
      if (observerTarget) observer.unobserve(observerTarget);
    };
  }, [list, isFinish]);

  const widthReturn = () => {
    switch (page) {
      case "cancle":
        return 90;
      case "refound":
        return 100;
      case "all":
        return 170;
      default:
        return null;
    }
  };

  return (
    <Layout_Admin menuname={"주문내역"}>
      <Order_select_menu ref={menuRef} go_page={go_page} />

      <RowView2>
        <SearchBox style={{ flex: 1, maxWidth: "40rem" }}>
          <div className="label">주문자</div>
          <RowView2>
            <select value={search_key} onChange={setting_search_key}>
              <option value={"order_name"}>주문자명</option>
              <option value={"order_nickname"}>닉네임</option>
              <option value={"addr_phone"}>연락처</option>
            </select>
            <input
              placeholder="주문자명, 입금자명, 연락처 검색"
              value={pre_search_value}
              onChange={setting_pre_search_value}
              onKeyDown={keyPress_keyword}
            />
          </RowView2>
        </SearchBox>
        <SearchBox>
          <div className="label">날짜</div>
          <RowView2>
            <input
              type={"date"}
              value={pre_search_startDt}
              onChange={setting_pre_search_startDt}
            />
            <span className="wave">~</span>
            <input
              type={"date"}
              value={pre_search_endDt}
              onChange={setting_pre_search_endDT}
            />
          </RowView2>
        </SearchBox>
        <SearchBox>
          <div className="label">품목</div>
          <RowView2>
            <CenterView
              className="redbtn"
              onClick={() => setOpen_productList(true)}
            >
              <Icon src={require("../../../Image/ic_square_white.png")} />
              품목 선택
            </CenterView>
            <CenterView className="btn" onClick={search}>
              검색
            </CenterView>
            <Icon
              className="reset"
              src={require("../../../Image/ic_reset_black.png")}
              onClick={reset}
            />
          </RowView2>

          <Product_list
            visible={open_productList}
            handleModal={handleOpen_productList}
            setSearch_item={setSearch_item}
          />
        </SearchBox>
      </RowView2>

      <SearchKeyword>
        {search_value && (
          <>
            <span>{search_value}</span>
            <Icon
              src={require("../../../Image/ic_x_gray.png")}
              onClick={del_search_value}
            />
          </>
        )}
        {(search_startDt || search_endDt) && (
          <>
            <span>{search_startDt}</span>
            <span style={{ margin: "0 5px" }}>~</span>
            <span>{search_endDt}</span>
            <Icon
              src={require("../../../Image/ic_x_gray.png")}
              onClick={del_search_date}
            />
          </>
        )}
        {search_item && (
          <>
            <span>{search_item}</span>
            <Icon
              src={require("../../../Image/ic_x_gray.png")}
              onClick={del_search_item}
            />
          </>
        )}
      </SearchKeyword>

      <RowView>
        {pagename !== "환불처리" && pagename !== "전체" ? (
          <OrderStatusArea className={loading_ ? "loading" : ""}>
            <div className="title">주문 상태 변경</div>

            {menuList.map((data, idx) => {
              return (
                <div
                  key={idx}
                  style={pagename === data ? { display: "none" } : {}}
                  className="btn"
                  onClick={() => set주문상태(data)}
                >
                  {data}
                </div>
              );
            })}
            {pagename !== "주문취소" && (
              <>
                <div className="btn" onClick={() => set주문상태("주문취소")}>
                  주문취소
                </div>
                <div className="btn" onClick={() => set주문상태("환불처리")}>
                  환불처리
                </div>
                <AllCheck
                  className={select_status ? "check" : ""}
                  onClick={set모든주문선택}
                >
                  <CheckBox
                    type={"checkbox"}
                    className="red"
                    checked={select_status !== ""}
                    readOnly
                  />
                  모든 주문 선택 ({total}건)
                </AllCheck>
              </>
            )}
          </OrderStatusArea>
        ) : (
          <div />
        )}

        <RowView2>
          <input
            ref={uploadRef}
            type={"file"}
            onChange={upload_xlxs}
            style={{ display: "none" }}
          />
          {/* {show_엑셀업로드 && (
            <Btn className="red" onClick={clickBtn}>
              엑셀 업로드
            </Btn>
          )} */}
          {show_엑셀내보내기 && (
            <Btn onClick={download_xlxs}>엑셀 내보내기</Btn>
          )}
          {show_삭제 && <Btn onClick={order_delete}>삭제</Btn>}
        </RowView2>
      </RowView>

      <ScrollBox>
        {["non-pay", "done-pay", "ready-deli", "done-deli"].includes(page) ? (
          <Order_paydeil
            list={list}
            total={total}
            selectOrder={selectOrder}
            setSelectOrder={setSelectOrder}
            modify_memo={modify_memo}
            select_status={select_status}
            setSelect_status={setSelect_status}
            page={page}
          />
        ) : page === "cancle" ? (
          <Order_cancel
            list={list}
            selectOrder={selectOrder}
            setSelectOrder={setSelectOrder}
            page={page}
          />
        ) : page === "refound" ? (
          <Order_refound list={list} modify_memo={modify_memo} page={page} />
        ) : (
          <Order_all list={list} page={page} />
        )}

        <Loding>
          {loading ? (
            <div className="loading" />
          ) : isFinish ? (
            <div>마지막 입니다.</div>
          ) : (
            <></>
          )}
        </Loding>

        {list.length !== 0 && !loading && (
          <Observer $width={widthReturn()} id="observer" />
        )}
      </ScrollBox>

      <Test>
        {search_value}
        <br />
        {search_startDt}
        <br />
        {search_endDt}
        <br />
        {currentPage}
        <br />
        {list.length}
      </Test>
      <No_stock visible={stockModal} handleModal={handleStockModal} />
    </Layout_Admin>
  );
};

export default Orderlist;

const SearchBox = styled.div`
  position: relative;
  margin-bottom: 1rem;
  margin-right: 1rem;
  div.label {
    margin-bottom: 0.5rem;
    ${fontStyles.semiBold}
    font-size: 18px;
  }
  select {
    height: 3rem;
    padding: 0rem 1rem;
    margin-right: 0.5rem;
    font-size: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    cursor: pointer;
    &:hover,
    &:focus {
      border: 1px solid #454545;
    }
  }
  input {
    box-sizing: border-box;
    flex: 1;
    height: 3rem;
    padding: 1rem;
    font-size: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    &:hover,
    &:focus {
      border: 1px solid #454545;
    }
  }
  span.wave {
    ${fontStyles.medium}
    margin: 0 1rem;
  }
  div.redbtn {
    width: 7em;
    height: 3rem;
    padding-right: 0.5rem;
    margin-right: 3rem;
    ${fontStyles.semiBold}
    color: white;
    background: linear-gradient(135deg, #7955f0, #3209b9);
    border-radius: 8px;
    cursor: pointer;
    img {
      width: 24px;
      margin-right: 5px;
    }
  }
  div.btn {
    width: 5rem;
    height: 3rem;
    ${fontStyles.semiBold}
    color: white;
    background-color: #2d2d2d;
    border-radius: 8px;
    cursor: pointer;
  }
  img.reset {
    padding: 0.5rem;
    margin-left: 0.5rem;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    cursor: pointer;
  }
`;
const SearchKeyword = styled(RowView2)`
  margin-bottom: 2rem;
  white-space: nowrap;
  img {
    width: 24px;
    margin-left: 5px;
    margin-right: 1rem;
    cursor: pointer;
  }
`;
const OrderStatusArea = styled(RowView2)`
  white-space: nowrap;
  div {
    margin-right: 1rem;
  }
  div.title {
    ${fontStyles.semiBold}
    font-size: 20px;
  }
  div.btn {
    padding: 0.5rem 1rem;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    cursor: pointer;
  }
  &.loading > div.btn {
    cursor: wait;
  }
`;
const AllCheck = styled(RowView2)`
  ${fontStyles.medium};
  color: #8e8e8e;
  cursor: pointer;
  input {
    margin-right: 0.5rem;
    background-color: #e7e7e7;
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
  }
  &.check {
    color: #eb003b;
  }
`;
const Btn = styled.div`
  padding: 0.5rem 1.8rem;
  margin-left: 1rem;
  ${fontStyles.medium}
  white-space: nowrap;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  cursor: pointer;
  &.red {
    color: white;
    background: linear-gradient(135deg, #7955f0, #3209b9);
    border: 0;
  }
`;
const Loding = styled(CenterView)`
  height: 3rem;
  color: #858585;
  div.loading {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border: 3px solid rgba(0, 0, 0, 0.3);
    border-top-color: #000000;
    border-radius: 100%;
    animation: spin 1s ease-in-out infinite;
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;
const ScrollBox = styled.div`
  width: 100%;
  margin-top: 1rem;
`;
const Observer = styled.div<{ $width?: number | null }>`
  width: ${(props) => (props.$width ? `${props.$width}rem` : "240rem")};
  height: 1rem;
  background-color: white;
`;
const Test = styled.div`
  position: fixed;
  top: 0;
  margin-top: 1rem;
  padding: 1rem;
  background-color: white;
  border: 1px solid red;
  border-radius: 8px;
  display: none;
`;
